export default "__VITE_ASSET__8DF5PPR2__"